import React, { createContext, useCallback, useContext } from 'react';
import usePostMessage from '../hooks/usePostMessage';
import { useDispatch } from 'react-redux';
import { importUseCli } from '../utils/dynamic-imports-sl-cli';
import { doAddConsoleLine } from '../redux/cli/commandActions';

const MessageCommunicationContext = createContext(null);

export const MessageCommunicationProvider = ({ children }) => {
  const dispatch = useDispatch();
  const useCli = importUseCli();
  const cli = useCli();

  const handleOnMessage = useCallback(
    (formEvent) => {
      const { data } = formEvent;

      try {
        const dataJSON = JSON.parse(data);

        const cmd = dataJSON?.cmd;
        const params = dataJSON?.params;

        if (cmd) {
          let buildedParams = '';

          params &&
            Object.entries(params).forEach(([key, val]) => {
              if (typeof val === 'object') {
                buildedParams = `${buildedParams} ${key}:'${JSON.stringify(
                  val
                )}'`;
              } else {
                buildedParams = `${buildedParams} ${key}:'${val.replaceAll(
                  ',',
                  ''
                )}'`;
              }
            });

          const buildedCommand = `${cmd}${buildedParams}`;

          cli.execCommand(buildedCommand);
        }
      } catch (error) {
        dispatch(doAddConsoleLine({ errors: error }));
        throw error;
      }
    },
    [cli, dispatch]
  );

  const { postMessage } = usePostMessage((message) => {
    handleOnMessage({ formId: 'PARENT', control: 'X', data: message });
  });

  return (
    <MessageCommunicationContext.Provider value={{ postMessage }}>
      {children}
    </MessageCommunicationContext.Provider>
  );
};

export const useMessageCommunicationContext = () => {
  const context = useContext(MessageCommunicationContext);
  if (!context) {
    throw new Error(
      'useMessageCommunicationContext must be used within a MessageCommunicationProvider'
    );
  }
  return context;
};
